import { Building2, CircleAlert, CircleCheck, Link2, Link2Off, ShieldOff, Trash2 } from "lucide-react";
import type { PatientActivityEvent } from "@/server/schema/admin";

/** Direct lookup from event kind to its feed icon and color. */
export const KIND_ICON: Record<
  PatientActivityEvent["kind"],
  { Icon: typeof CircleCheck; className: string }
> = {
  records_synced: { Icon: CircleCheck, className: "text-emerald-600 dark:text-emerald-400" },
  sync_failed: { Icon: CircleAlert, className: "text-destructive" },
  link_generated: { Icon: Link2, className: "text-muted-foreground" },
  link_expired: { Icon: Link2Off, className: "text-amber-600 dark:text-amber-400" },
  link_opened: { Icon: Link2, className: "text-muted-foreground" },
  source_linked: { Icon: Building2, className: "text-primary" },
  records_deleted: { Icon: Trash2, className: "text-destructive" },
  access_revoked: { Icon: ShieldOff, className: "text-amber-600 dark:text-amber-400" },
};
